module.exports = __webpack_public_path__ + "static/img/xz2.871e265.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xz2.png
// module id = 1036
// module chunks = 1